import request from '@/utils/request'


export function list(form) {
    return request.post('/goods/list', form);
}
// -----------------------------------------------
// 新增
export function scoreHistory(form) {
    return request.post('/goods/scoreHistory', form);
}
// -----------------------------------------------
export function detail(id) {
    return request.post('/goods/detail', { id });
}

export function getSku(skuId) {
    return request.post('/goods/getsku', { skuId });
}

export function placeList() {
    return request.post('/goods/placelist');
}
export function getPlace(id) {
    if (id) {
        return request.post('/goods/getplace', { placeId: id });
    } else {
        return request.post('/goods/getplace');
    }
}

export function createOrder(form) {
    return request.post('/goods/createorder', form);
}

export function getOrder(id) {
    return request.post('/goods/getorder', { orderId: id });
}
export function getRecommend(id) {
    return request.post('/goods/getrecommend', { goodsId: id });
}

export function pay(id, isWx, code) {
    return request.post('/goods/pay', { orderId: id, isWx: isWx, code: code });
}

export function orderList(form) {
    return request.post('goods/orderlist', form);
}

export function salesReturn(form) {
    return request.post('goods/salesreturn', form);
}

export function confirmOrder(id) {
    return request.post('goods/confirmorder', { orderId: id });
}

export function queryOrder(id) {
    return request.post('goods/queryorder', { orderId: id });
}

export function saveInfo(code) {
    return request.post('goods/saveInfo', { code: code });
}

/**
 * 获得产品利率的百分比
 * @param {*}
 */
export function getScoreRate() {
    return request.post('/goods/getScoreRate', { chanlCode: "BL" });
}

export function getGoodsTemplate(templateId) {
    return request.get(`/goods/template/${templateId}`)
}